// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1Jbdu","calendarButtons":"ClockData_calendarButtons__1FwsM"};